import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const InvoiceListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${(props) => props.marginTop ?? "30px"};
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const OuterWrapper = styled.div`
  padding: 1rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => props.justifyContent ?? "normal"};
  align-items: ${(props) => props.alignItems ?? "normal"};
  margin-right: ${(props) => props.marginRight ?? "0px"};
  padding: ${(props) => props.padding ?? "0px"};
  > div {
    margin-right: 0.5rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: flex-end;
  border: 1px solid #1bace4;
  padding: 10px;
  border-radius: 5px;
`;
export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  column-gap: 1rem;
`;
export const ActionOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: auto;
  column-gap: 1rem;
`;
export const InvoiceServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;
export const HeaderGridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;
export const GridItem = styled.div`
  border-right: ${(props) => props.borderRight ?? "2px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #fff;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#0A4986"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-radius: ${(props) => props.radius ?? "0px 0px 0px 0px"};
  align-content: ${(props) => props.alignContent ?? "flex-start"};
  justify-content: ${(props) => props.justifyContent ?? "normal"};
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  font-weight: normal;
  gap: ${(props) => props.padding ?? "0px"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
`;
export const HeaderWrapperTable = styled.div`
  background-color: #fff;
  display: table-column-group;
  justify-content: space-between;
  border-radius: 0px 0px 0px 0px;
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: ${(props) => props.fontWeight ?? "700"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  padding: ${(props) => props.padding ?? "5px"};
  align-content: ${(props) => props.alignContent ?? "center"};
`;

export const DocumentRow = styled.div`
  padding-left: 5px;
  margin-bottom: 0.2rem;
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: #1bace4 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  position: relative;
`;

export const FilterItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: 5px;
`;

export const FilterLabel = styled.label`
  vertical-align: text-top;
  margin-bottom: 7px;
  font-weight: 700;
  font-size: 1rem;
  font-family: "Lato";
  color: #1bace4;
  line-height: 1;
  text-transform: initial;
`;

export const FilterContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const GridItemOuter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent ?? "center"};
`;
export const Title = styled.h2`
  width: ${({ inline }) => (inline ? "auto" : "100%")};
  text-align: ${({ inline }) => (inline ? "right" : "center")};
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: ${({ inline }) => (inline ? "0" : "0 0 30px 0")};
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const SortIconOuter = styled.span`
  padding-left: 5px;
`;